function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.secondary = this.querySelector('.product-featured-image-link .product-secondary-image');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches();
      }
      if (this.quick_add) {
        this.enableQuickView();
      }
      if (this.secondary) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(this.secondary);
        });
      }
    }
    enableSwatches() {
      let swatch_list = this.swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = this.image ? this.image.dataset.srcset : '';


      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('mouseover', () => {

          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (this.image) {
            if (swatch.dataset.srcset) {
              this.image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              this.image.setAttribute('srcset', org_srcset);
            }
          }

          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickView() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');

        dispatchCustomEvent('cart-drawer:open');
      }

    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {

  constructor() {
    super();
    let cc = document.querySelector('.click-capture');

    // Add functionality to buttons
    this.addEventListener('click', (e) => this.close_panel(e));
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          document.querySelectorAll('.side-panel').forEach((panel) => {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
          });
        }
      }
    });
    cc.addEventListener('click', (e) => {
      document.body.classList.remove('open-cc');
      if (document.querySelector('.side-panel.active')) {
        document.querySelector('.side-panel.active').classList.remove('active');
      }
    });
  }

  close_panel(e) {
    e.preventDefault();
    let panel = e.target.closest('.side-panel');
    panel.classList.remove('active');
    document.body.classList.remove('open-cc');
  }
}
customElements.define('side-panel-close', PanelClose);

/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {

  constructor() {
    this.container = document.getElementById('Cart-Drawer');

    if (!this.container) {
      return;
    }
    let _this = this,
      button = document.getElementById('cart-drawer-toggle'),
      quantities = this.container.querySelectorAll('.quantity input'),
      removes = this.container.querySelectorAll('.remove');

    if (!button) {
      return;
    }
    // Add functionality to buttons
    button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      this.container.classList.add('active');
      this.container.focus();

      dispatchCustomEvent('cart-drawer:open');
    });


    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.notesToggle();
    this.removeProductEvent();
    // Terms checkbox
    this.termsCheckbox();
  }
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      this.updateCartItem(event.target.dataset.index, event.target.value);
    }
    this.removeProductEvent();
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        event.preventDefault();
        this.updateCartItem(event.target.dataset.index, '0');

      });
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartDrawerTerms'),
      checkout_button = this.container.querySelector('.button.checkout');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
  }
  async updateCartItem(line, quantity) {
    const cartDrawerItem = this.container.querySelector(`#CartDrawerItem-${line}`);
    if (cartDrawerItem) {
      cartDrawerItem.classList.add('thb-loading');
    }
  
    const cartElement = this.container.querySelector('[data-cart-json]');
    const cartData = JSON.parse(cartElement.textContent);
    const { cart } = cartData;
    const targetIndex = line - 1;
    const targetItem = cart.items[targetIndex];
  
    const targetPropertiesValues = Object.values(targetItem.properties);
    
    const matchingItems = cart.items.filter(item => {
      if (item.properties._addon_product && item.properties._general_product_id == targetItem.product_id) {
        const itemPropertiesValues = Object.values(item.properties);
        return itemPropertiesValues.some(value => targetPropertiesValues.includes(value));
      }
    });
  
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname
    });
  
    dispatchCustomEvent('line-item:change:start', { quantity });
  
    const updateCart = async (body) => {
      const response = await fetch(theme.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body
      });
      const state = await response.json();
      return state;
    };
  
    const updateAddonQuantity = async (addonBody) => {
      const response = await fetch('/cart/update.js', {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: addonBody,
      });
      const state = await response.json();
      return state;
    };
  
    try {
      const cartState = await updateCart(body);
      const parsedCartState = cartState;
  
      this.getSectionsToRender().forEach(section => {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedCartState.sections[section.section], section.selector);
        if (section.id === 'cart-drawer-toggle') {
          const countText = elementToReplace.innerText.trim();
          const count = parseInt(countText, 10);
          console.log(count);
          if (count > 0) {
            elementToReplace.classList.add('thb-item-count--active');
          } else {
            elementToReplace.classList.remove('thb-item-count--active');
          }
        }
      });
  
      if (matchingItems && !targetItem.properties.addon_product) {
        const addonUpdateData = matchingItems.map(matchingItem => {
          let addonQuantity = 0;
          if (quantity == 0 && matchingItem.quantity >= targetItem.quantity) {
            addonQuantity = matchingItem.quantity - targetItem.quantity;
          } else if (quantity > 0 && matchingItem.quantity >= targetItem.quantity) {
            addonQuantity = +quantity + matchingItem.quantity - targetItem.quantity;
          } else if (quantity > 0 && matchingItem.quantity == targetItem.quantity) {
            addonQuantity = +quantity;
          } else if (quantity > 0 && quantity < targetItem.quantity) {
            addonQuantity = matchingItem.quantity - +quantity;
          }
          return { [matchingItem.key]: addonQuantity };
        });
        const addonBody = JSON.stringify({
          updates: Object.assign({}, ...addonUpdateData),
          sections: this.getSectionsToRender().map(section => section.section),
          sections_url: window.location.pathname
        });
    
        const addonState = await updateAddonQuantity(addonBody);
    
        this.getSectionsToRender().forEach(section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(addonState.sections[section.section], section.selector);
        });
      }
  
      this.removeProductEvent();
      this.notesToggle();
      this.termsCheckbox();
  
      dispatchCustomEvent('line-item:change:end', { quantity, cart: parsedCartState });
  
      if (cartDrawerItem) {
        cartDrawerItem.classList.remove('thb-loading');
      }
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this));

    }
    setupCCEventListener(e) {
      this.body.classList.remove('open-cc');
      this.drawer.classList.remove('active');
      this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);



        this.body.classList.add('open-cc');
        this.drawer.classList.add('active');
        this.drawer.querySelector('.side-panel-close').focus();

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.classList.add('product-recommendations--loaded');
      })
      .catch(e => {
        console.error(e);
      });
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/**
 *  @class
 *  @function Localization
 */
class Localization {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".thb-localization-forms").forEach((localization) => {
      localization.addEventListener("change", (e) => {
        localization.querySelector('form').submit();
      });
    });
  }
}



/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);

    // delegated listener on change
    document.body.addEventListener("change", (e) => {
      if (e.target.matches(".resize-select") && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select');
    tempSelect.style.visibility = "hidden";
    tempSelect.style.position = "fixed";
    tempSelect.appendChild(tempOption);

    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + 12}px`;
    }
    tempSelect.remove();
  }
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector('summary').offsetHeight,
        content_height = this.querySelector('.collapsible__content').offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height;

      this.tl = false;
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: 'none',
        onStart: function () {
          _this.details.open = true;
          _this.details.style.overflow = 'hidden';
        },
        onReverseComplete: function () {
          _this.details.open = false;
          _this.details.style.overflow = '';
        }
      });

      this.tl
        .fromTo(_this.details, {
          height: function () {
            let h = Math.max(Math.max(initial_height, 0), 24);
            return h;
          },
          clearProps: 'height'
        }, {
          duration: 0.4,
          height: final_height,
          clearProps: 'height'
        });

      if (this.details.open) {
        this.tl.progress(1);
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}
document.addEventListener('DOMContentLoaded', () => {

  if (typeof Localization !== 'undefined') {
    new Localization();
  }
  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer();
  }

});

/*============================================================================
  Collection Fabric Section
==============================================================================*/

class CollectionFabricElement extends HTMLElement {

  constructor() {
    super();
    this.init();
  }

  init() {
    this.cartState = [];
    this.container = this;
    this.contentContainer = this.container.querySelector('.collection__page-content-container');
    this.emptyInfoContainer = this.container.querySelector('#main-collection-product-grid-subs');
    this.productsContainer = this.container.querySelector('.content-container__subcategories');
    this.cartBar = document.querySelector('.swatches-cart-container');
    this.maxProductInCart = parseInt(this.container.dataset.maxProductInCart);
    this.orderSwatchesBtn = this.cartBar.querySelector('.cart-container__button-container button');
    this.cartBarSwatchesContainer = this.cartBar.querySelector('.products-container__swatchers');
    this.cartBarSwatchesMobileContainer = this.cartBar.querySelector('.products-container__swatchers-mobile');
    this.emptyBarSwatchesText = this.cartBar.querySelector('[data-empty-swatches-container]');
    this.productsContainerSwatches = document.querySelector('.cart-container__products-container');
    this.filtrationBar = document.querySelector('#swatch_select_head');
    this.quickBuyContainer = this.container.querySelector('.content-container__quick-buy-container');
    this.quickBuyAtcBtn = this.quickBuyContainer.querySelector('.quick-buy__buttons .atc-button');
    this.currentCollectionLink = new URL(window.location.href);
    this.linkParams = new URLSearchParams(this.currentCollectionLink.search);

    this.setProductCardListeners(this.container);
    this.setCartBarListeners();
    this.setFiltrationBarListeners();
    this.setQuickBuyAtcBtnListener(this.quickBuyAtcBtn);
    this.fancyboxInitialization();
    this.initProductInCart();
    this.initAnimateOpenClose();
  }

  initAnimateOpenClose() {
    const details = document.querySelector('.collapsible-row details');
    const summary = details.querySelector('summary');
    details.addEventListener('toggle', (event) => {
      const isOpen = details.open;
      const mainProductContainer = this.productsContainerSwatches.querySelector('.products-container__swatchers');
      const children = mainProductContainer.querySelector('.swatch__container');
      if (children) {
        if (isOpen) {
          this.productsContainerSwatches.classList.remove('close-animation');
          this.productsContainerSwatches.classList.add('open-animation');
        }
      }
    });
    summary.addEventListener('click', (event) => {
      const isOpen = details.open;
      const mainProductContainer = this.productsContainerSwatches.querySelector('.products-container__swatchers');
      const children = mainProductContainer.querySelector('.swatch__container');
      if (children) {
        if (isOpen) {
          this.productsContainerSwatches.classList.remove('open-animation');
          this.productsContainerSwatches.classList.add('close-animation');
        }
      }
    });

  }
  
  setProductCardListeners(container) {
    const productCards = container.querySelectorAll('div.product-card-container__product-card');
    productCards.forEach(card => card.addEventListener('mouseenter', (event) => this.quickBuyCardChange(event)));
    productCards.forEach(card => card.addEventListener('click', (event) => this.toggleCartState(card, event)));
  }

  setCartBarListeners() {
    this.cartBar.addEventListener('click', this.removeProductFromCart.bind(this));
    this.orderSwatchesBtn.addEventListener('click', this.submitCart.bind(this));
  }

  setFiltrationBarListeners() {
    const colorFilters = this.filtrationBar.querySelectorAll('#swatch_select_head li[data-value]');
    colorFilters.forEach(filter => filter.addEventListener('click', this.toggleFilterState.bind(this, filter)));
  }

  setQuickBuyAtcBtnListener(atcBtn) {
    atcBtn.addEventListener('click', (e) => {
      const productId = e.target.closest('.quick-buy__buttons').dataset.productId;
      const productCard = this.container.querySelector(`.product-card-container__product-card[data-product-id="${productId}"]`);
      this.toggleCartState(productCard, e);
    })
  }

  fancyboxInitialization() {
    Fancybox.bind('[data-fancybox]', {
      on: {
        reveal: (fancybox, slide) => {
          const fancyboxButtons = slide.contentEl.querySelector('.quick-buy__buttons');
          console.log('fancyboxButtons', fancyboxButtons)
          const atcBtn = fancyboxButtons.querySelector('.atc-button');
          const fancyboxProductId = atcBtn.dataset.productId;
          const isInCart = this.cartState.find(({productId}) => productId === parseInt(fancyboxProductId));
          if (!atcBtn.dataset.listener) {
            atcBtn.classList.toggle('added-to-cart', !!isInCart);
            this.setQuickBuyAtcBtnListener(atcBtn);
            atcBtn.setAttribute('data-listener', true);
          }
        }
      },
    });
  }

  initProductInCart() {
    this.cartBarSwatchesContainer.querySelectorAll('.swatch__container').forEach(cartSwatch => {
      const productId = cartSwatch.dataset.productId;
      const productCard = this.container.querySelector(`.product-card-container__product-card[data-product-id="${productId}"]`);
      this.toggleCartState(productCard);
    })
  }

  toggleFilterState(filter, event) {
    event.preventDefault();
    const filterParam = filter.dataset.value;
    const filterName = filter.closest('[data-filter-name]').dataset.filterName;
    if (this.linkParams.getAll(filterName).includes(filterParam)) {
      const newParams = this.linkParams.toString().replace(`${filterName}=${filterParam}`, '');
      this.linkParams = new URLSearchParams(newParams);
      this.toggleFilterCardState(filter, false);
    } else {
      this.linkParams.append(filterName, filterParam);
      this.toggleFilterCardState(filter, true);
    }
    this.fetchNewResults();
  }

  fetchNewResults() {
    this.productsContainer.classList.toggle('fetching', true);
    fetch(`${window.location.pathname}?${this.linkParams.toString()}`)
    .then(response => response.text())
    .then(data => {
      const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        this.cartState.forEach(({productId}) => 
          this.toggleCardState(doc.body.querySelector(`[data-product-id="${productId}"]`), true));
        const cartContainerElement = doc.body.querySelector('.content-container__subcategories')?.innerHTML;
        if (cartContainerElement) {
          console.log('loading', cartContainerElement)
          this.productsContainer.innerHTML = cartContainerElement;
          this.setProductCardListeners(this.container);
          this.contentContainer.classList.toggle('subcollection--empty', false);
          this.emptyInfoContainer.classList.toggle('subcollection--empty', true);
        } else {
          this.contentContainer.classList.toggle('subcollection--empty', true);
          this.emptyInfoContainer.classList.toggle('subcollection--empty', false);
        }
        this.productsContainer.classList.toggle('fetching', false);

    })
  }

  quickBuyCardChange(event) {
    const quickBuyCard = document.querySelector('div.content-container__quick-buy');
    const productCardImageHtml = event.target.querySelector('.product-card__image-wrapper>img').outerHTML;
    const productJson = JSON.parse(event.target.querySelector('script').innerHTML);
    const quickBuyTitle = quickBuyCard.querySelector('.quick-buy__title');
    const quickBuyDesc = quickBuyCard.querySelector('.quick-buy__description');
    const quickBuyImage = quickBuyCard.querySelector('.quick-buy__image-wrapper');
    const quickBuyCollection = quickBuyCard.querySelector('.quick-buy__subcategory');
    const quickBuyButtonsContainer = quickBuyCard.querySelector('.quick-buy__buttons');
    const quickBuyAtcBtn = quickBuyCard.querySelector('.quick-buy__buttons .atc-button');
    const quickBuyDetailsBtn = quickBuyCard.querySelector('button.details-button');
    const isInCart = this.cartState.find(({productId}) => productId === parseInt(productJson.first_available_variant_id));


    quickBuyTitle.innerText = productJson.title;
    quickBuyDesc.innerHTML = productJson.short_description;
    quickBuyImage.innerHTML = productCardImageHtml;
    if(quickBuyCollection) quickBuyCollection.innerText = productJson.fabric_collection_name;
    quickBuyButtonsContainer.setAttribute('data-product-id', productJson.first_available_variant_id);
    quickBuyDetailsBtn.setAttribute('data-src', productJson.fancybox_id);
    quickBuyDetailsBtn.setAttribute('data-fancybox', productJson.fancybox_gallery_id);
    quickBuyAtcBtn.classList.toggle('added-to-cart', !!isInCart);
  }

  toggleCartState(card, event) {
    if (event?.target.closest('[data-src]')) return;
    const productId = JSON.parse(card.querySelector('script').innerHTML).first_available_variant_id;

    let productCardImageHtml = card.querySelector('.product-card__image-wrapper>img').outerHTML;
    productCardImageHtml = event ? productCardImageHtml : productCardImageHtml.replace('lazyload', 'lazyloaded no-blur').replace('20x20', '360x360');
    const productCardTitleHtml = card.querySelector('.product-card__title').outerHTML;
    const cartSwatchElement = `<div class="swatch__container" data-product-id="${productId}">
                                ${productCardImageHtml}
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="w-6 h-6 remove-icon">
                                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                                </svg> 
                              </div>`
    const cartSwatchElementMobile = `<div class="swatch__container-mobile" data-product-id="${productId}">
                                        <div class="row__content">
                                          ${productCardImageHtml}
                                          ${productCardTitleHtml}
                                        </div>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-6 h-6 remove-icon">
                                          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                                        </svg>
                                      </div>`
    const cartObject = {
      productId,
      cartSwatchElement,
      cartSwatchElementMobile
    };

    const objectInCartState = this.cartState.find(({productId}) => productId === cartObject.productId);

    if (this.cartState.find(({productId}) => productId === cartObject.productId)) {
      this.cartState.splice(this.cartState.indexOf(objectInCartState), 1);
      this.toggleCardState(card, false);
    } else {
      if (this.cartState.length >= this.maxProductInCart) {
        Fancybox.show([
          {
            src: "#reached-limit-modal",
            type: "inline"
          },
        ]);
        return
      }
      this.cartState.push(cartObject);
      this.toggleCardState(card, true);
    }

    this.updateCartBar();
  }

  toggleCardState(card, enable) {
    card?.classList.toggle('added-to-cart', enable);

    const productId = card?.dataset.productId;
    const quickBuyButtonContainers = document.querySelectorAll(`.quick-buy__buttons[data-product-id="${productId}"]`);

    quickBuyButtonContainers &&
    quickBuyButtonContainers.forEach(container => container.querySelector('.atc-button').classList.toggle('added-to-cart', enable));


  }

  toggleFilterCardState(filter, enable) {
    filter.classList.toggle('applied', enable);
  }

  removeProductFromCart(event) { 
    if (event.target.closest('.swatch__container') || event.target.classList.contains('swatch__container')) {
      const productToRemove = event.target.classList.contains('swatch__container') ? event.target : event.target.closest('.swatch__container');
      const idProductToRemove = productToRemove.dataset.productId;

      const objectInCartState = this.cartState.find(({productId}) => productId === parseInt(idProductToRemove));
      const productCard = this.container.querySelector(`[data-product-id="${idProductToRemove}"]`);
      this.toggleCardState(productCard, false);

      this.cartState.splice(this.cartState.indexOf(objectInCartState), 1);
      this.updateCartBar();
    }
    if (event.target.closest('.remove-icon')) {
      const productToRemove = event.target.classList.contains('swatch__container-mobile') ? event.target : event.target.closest('.swatch__container-mobile');
      const idProductToRemove = productToRemove.dataset.productId;

      const objectInCartState = this.cartState.find(({productId}) => productId === parseInt(idProductToRemove));
      const productCard = this.container.querySelector(`[data-product-id="${idProductToRemove}"]`);
      this.toggleCardState(productCard, false);

      this.cartState.splice(this.cartState.indexOf(objectInCartState), 1);
      this.updateCartBar();
    }
  }

  updateCartBar() {
    const details = document.querySelector('.collapsible-row details');
    const swatchElements = this.cartState.map(object => object.cartSwatchElement);
    const swatchElementsMobile = this.cartState.map(object => object.cartSwatchElementMobile);
    this.emptyBarSwatchesText.classList.toggle('visually-hidden', swatchElementsMobile.length > 0);
    this.orderSwatchesBtn.disabled = swatchElementsMobile.length > 0 ? false : true;
    if (this.productsContainerSwatches.classList.contains('close-animation') && swatchElementsMobile.length <= 0) {
      this.productsContainerSwatches.classList.remove('close-animation');
    }
    if (details.open && swatchElementsMobile.length == 1) {
      this.productsContainerSwatches.classList.add('open-animation');
    }
    this.cartBarSwatchesContainer.innerHTML = swatchElements.join('');
    this.cartBarSwatchesMobileContainer.innerHTML = swatchElementsMobile.join('');
  }

  async submitCart(event) {
    event.preventDefault();
    if (this.cartState.length === 0) return;
    let addToCartData = {
      items: this.cartState.map(({productId}) => ({
        quantity: "1",
        id: productId,
        'properties': {
          '_swatchesCollection': true
        }
      }))
    };

    await this.checkIfSwatchInCart();

    const params = {
      method: 'POST',
      body: JSON.stringify(addToCartData),
      headers: {
        'Content-Type': 'application/json',
      },
    };


    fetch('/cart/add.js', params).then(() => window.location.href = '/checkout');
  }

  async checkIfSwatchInCart() {
    function convertArrayToObject(arr) {
      return arr.reduce((obj, item) => {
        obj[item.id] = 0;
        return obj;
      }, {});
    }
    const request = await fetch('/cart.js');
    const data = await request.json();
    const swatchesToRemove = data.items.filter(item => item.properties._swatchesCollection);
    if (swatchesToRemove.length === 0) return;
    const swatchesToRemoveData = {
      updates: convertArrayToObject(swatchesToRemove)
    };

    const params = {
      method: 'POST',
      body: JSON.stringify(swatchesToRemoveData),
      headers: {
        'Content-Type': 'application/json',
      },
    }
    await fetch('/cart/update.js', params);
  }
}

customElements.define('collection-fabric', CollectionFabricElement);